(function($) {
    if( $('body.home').length ) {

        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

        /*if(window.innerWidth < 769){
            $('.dynamic-content-center-image .content-wrapper div').each(function(){
                $(this).attr('data-speed', 1);
            });
        }*/

        if(window.innerWidth > 768){

            let smoother = ScrollSmoother.create({
                content: "#content",
                smooth: 3,
                effects: true,
                normalizeScroll: true,
                smoothTouch: 0.1
            });

            $(".nav-toggle").on('click', function () {
                setTimeout(function () {
                if( $("nav.main-nav").hasClass('open') ){
                    smoother.paused(true);
                } else {
                    smoother.paused(false);
                }
                }, 500);
            });

            /*if($('.dynamic-content-center-image .image').length){
                const images = gsap.utils.toArray(".dynamic-content-center-image .image.fade img");

                images.forEach((image, i) => {
                    gsap.to(image, {
                        opacity: 0,
                        ease: "none",
                        scrollTrigger: {
                            trigger: image,
                            start: "top",
                            end: "top",
                            scrub: true
                        }
                    });
                });
            }*/




            if ($('.stackingcard').length > 1) {

                let timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".stackingcards",
                        pin: true,
                        markers: false,
                        scrub: true,
                        start: "top-=10 10%",
                        end: "bottom top",
                        invalidateOnRefresh: true,
                        toggleActions: "play none none reverse",
                    }
                });

                // Add a delay before the animation starts
                timeline
                    .addPause(1.5) // Half a second delay
                    .fromTo(
                        ".stackingcard:not(:first-child)",
                        {
                            x: () => window.innerWidth / 2 + 350,
                            rotate: -90,
                        },
                        {
                            x: 0,
                            stagger: 0.5,
                            rotate: 0,
                        }
                    );
            }

        }


    }
})( jQuery );
